import { EyeIcon } from '@heroicons/react/24/outline'
import DisplayShopName from '../common/DisplayShopName'

const ProductCard = ({ product, catalogProducts }) => {
  const name = product.name
  const views = product.totalProductViews ?? 0

  return (
    <div className="flex flex-col lg:flex-col items-start  lg:items-start border border-bids-border rounded-lg p-4 mb-3 lg:mb-0 bg-background shadow-sm hover:shadow-md transition-shadow duration-200 h-full">
      <div className="flex w-full  flex-col lg:w-full">
        <div className="flex-shrink-0  h-48 w-full   lg:mr-0 mb-2  lg:mb-4">
          <img
            src={product.primaryImageUrl}
            alt={name}
            className="w-full h-full object-scale-down  rounded lg:rounded-lg"
            onError={(e) => {
              e.target.onerror = null
              e.target.src = '/placeholder-image.png'
            }}
          />
        </div>

        <div className="flex-1 flex flex-col justify-center lg:justify-start text-sm text-gray-800 min-w-0 lg:flex-grow">
          <span className="font-medium text-base truncate">{name}</span>
          {catalogProducts && (
            <div className="text-secondary-600 inline lg:mt-2">
              <DisplayShopName
                shop={{
                  isVerified: product?.isShopVerified,
                  isPremium: product?.isShopPremium,
                  name: product?.shopName,
                }}
                showIconsOnMobile={false}
              />
            </div>
          )}
        </div>
      </div>

      <div className="sm:ml-0 lg:ml-0 flex  flex-col  md:gap-0 lg:flex-row lg:justify-between lg:items-center lg:mt-auto lg:pt-2 lg:w-full">
        <span className="font-bold text-lg lg:text-lg text-foreground-secondary">
          {product?.priceText}
        </span>
        <span className="flex items-center text-foreground-700 text-sm lg:text-xs text-primary-600">
          <EyeIcon className="w-4 h-4 mr-1 text-primary-600" />
          {views}
        </span>
      </div>
    </div>
  )
}

export default ProductCard
